import { LoginAdmin, OtpAdmin } from '../adminPages';

export const ADMIN_ROOT = '';
export const ADMIN_LOGIN = `${ADMIN_ROOT}/login`;
export const ADMIN_OTP = `${ADMIN_ROOT}/otp`;

export const ADMIN_DASHBOARD = `${ADMIN_ROOT}/dashboard`;

export const ADMIN_VERIFICATIONS = `${ADMIN_ROOT}/verifications`;
export const ADMIN_VERIFICATIONS_RESTAURANT = `${ADMIN_ROOT}/verifications/restaurant/:id`;
export const ADMIN_VERIFICATIONS_V_DRIVE = `${ADMIN_ROOT}/verifications/v-drive/:id`;
export const ADMIN_VERIFICATIONS_AGENT = `${ADMIN_ROOT}/verifications/agent/:id`;
export const ADMIN_VERIFICATIONS_BRAND = `${ADMIN_ROOT}/verifications/brand/:id`;
export const ADMIN_USERS = `${ADMIN_ROOT}/users`;
export const ADMIN_USERS_DETAILS = `${ADMIN_ROOT}/users/:id`;
export const ADMIN_USER_DETAILS_AGENT = `${ADMIN_ROOT}/users/agent/:id`;
export const ADMIN_USER_DETAILS_AGENT_LOCATIONS = `${ADMIN_ROOT}/users/agent/:id/locations`;
export const ADMIN_USER_DETAILS_AGENT_AGENTS = `${ADMIN_ROOT}/users/agent/:id/agents`;
export const ADMIN_TRANSACTIONS = `${ADMIN_ROOT}/transactions/:id`;
export const ADMIN_AGENT_TRANSACTIONS = `${ADMIN_ROOT}/transactions/agent/:id`;
export const ADMIN_USER_TRANSACTIONS_PENDING_LOCATION = `${ADMIN_ROOT}/wallet-pending/:id/:locationId`;

export const ADMIN_LOCATIONS = `${ADMIN_ROOT}/locations`;
export const ADMIN_LOCATIONS_DETAILS = `${ADMIN_ROOT}/locations/:id`;
/** `?editLocation=1` on Location Details opens Edit Location once it loads. */
export const EDIT_LOCATION_PARAM = 'editLocation';
export const ADMIN_LOCATIONS_CONNECT_BRANDS = `${ADMIN_ROOT}/locations/:id/connect-brands`;
export const ADMIN_LOCATIONS_CONNECT_BRANDS_EDIT_MENU_ITEM = `${ADMIN_ROOT}/locations/:id/connect-brands/edit-menu-item/:brandTemplateId`;
export const ADMIN_LOCATIONS_V_DRIVE = `${ADMIN_ROOT}/locations/v-drive/:id`;
export const ADMIN_LOCATIONS_V_DRIVE_ASSIGNMENT_STRATEGY = `${ADMIN_ROOT}/locations/v-drive/:id/assignment-strategy`;
export const ADMIN_LOCATIONS_ONBOARDING_V_DRIVE = `${ADMIN_ROOT}/locations/v-drive/onboarding/:id`;
export const ADMIN_BRAND_DETAILS = `${ADMIN_ROOT}/brand/:id`;
export const ADMIN_BRAND_V_DRIVE = `${ADMIN_ROOT}/brand/v-drive/:id`;
export const ADMIN_BRAND_V_DRIVE_ASSIGNMENT_STRATEGY = `${ADMIN_ROOT}/brand/v-drive/:id/assignment-strategy`;
export const ADMIN_LOCATION_MANAGE_PROVIDERS = `${ADMIN_ROOT}/locations/manage-providers/:id`;
export const ADMIN_BRAND_MANAGE_PROVIDERS = `${ADMIN_ROOT}/brands/manage-providers/:id/:locId`;

export const ADMIN_MENU = `${ADMIN_ROOT}/menu/:locationId/location/:brandId/brand`;
export const ADMIN_BRAND_TEMPLATE_MENU = `${ADMIN_ROOT}/templates-brand/menu/:brandTemplateId`;

export const ADMIN_WEBSITES = `${ADMIN_ROOT}/websites`;
export const ADMIN_WEBSITES_DETAILS = `${ADMIN_ROOT}/websites/:id`;
export const ADMIN_WEBSITES_ADD = `${ADMIN_ROOT}/websites/add`;
export const ADMIN_BLOGS = `${ADMIN_ROOT}/blogs`;
export const ADMIN_BLOGS_ADD = `${ADMIN_ROOT}/blogs/add`;
export const ADMIN_BLOGS_EDIT = `${ADMIN_ROOT}/blogs/:id`;
export const ADMIN_ANNOUNCEMENTS = `${ADMIN_ROOT}/announcements`;
/** One announcement: who saw it, where and when. */
export const ADMIN_ANNOUNCEMENT_DETAILS = `${ADMIN_ROOT}/announcements/:id`;
export const ADMIN_BRANDS = `${ADMIN_ROOT}/brands`;
export const ADMIN_BRANDS_ADD = `${ADMIN_ROOT}/brands/add`;
export const ADMIN_CONCIERGE = `${ADMIN_ROOT}/concierge`;
export const ADMIN_PRIVACY_POLICY = `${ADMIN_ROOT}/privacy-policy`;
export const ADMIN_TERMS_AND_CONDITIONS = `${ADMIN_ROOT}/terms-and-conditions`;
export const ADMIN_INCIDENT_MESSAGES = `${ADMIN_ROOT}/vdrive-tracking-tink`;
export const ADMIN_PAYOUTS = `${ADMIN_ROOT}/payouts`;
export const ADMIN_ORDERS = `${ADMIN_ROOT}/orders`;
export const ADMIN_ORDER_DETAILS = `${ADMIN_ROOT}/orders/:id`;
export const ADMIN_ADD_MANUAL_ORDER = `${ADMIN_ROOT}/orders/add-manual`;
export const ADMIN_EDIT_MANUAL_ORDER = `${ADMIN_ROOT}/orders/edit-manual`;
export const ADMIN_SETTINGS = `${ADMIN_ROOT}/settings`;
/** Under Settings, so the sidebar keeps Settings lit while it is open. */
export const ADMIN_SETTINGS_WHATS_NEW = `${ADMIN_SETTINGS}/whats-new`;
export const ADMIN_CLOSING_DAYS = `${ADMIN_ROOT}/closing-days`;
export const ADMIN_AUDIT_LOG = `${ADMIN_ROOT}/audit-log`;
export const ADMIN_WORKING_HOURS = `${ADMIN_ROOT}/working-hours`;
export const ADMIN_BRAND_TEMPLATES = `${ADMIN_ROOT}/templates-brand`;
export const ADMIN_CUSTOMER_STATS = `${ADMIN_ROOT}/customer-stats`;
export const ADMIN_CLIENT_PAYMENTS = `${ADMIN_ROOT}/client-payments`;
/**
 * "Outstanding Balances": what locations owe vGrubs (vDrive reserve, SaaS).
 * The code keeps the backend's word,
 * receivables; the old `/receivables` paths redirect here.
 */
export const ADMIN_RECEIVABLES = `${ADMIN_ROOT}/outstanding-balances`;
export const ADMIN_RECEIVABLES_LOCATION = `${ADMIN_ROOT}/outstanding-balances/:locationId`;
/** Shared before the rename (Oct 2026); kept as redirects. */
export const ADMIN_RECEIVABLES_OLD = `${ADMIN_ROOT}/receivables`;
export const ADMIN_RECEIVABLES_LOCATION_OLD = `${ADMIN_ROOT}/receivables/:locationId`;
export const ADMIN_DELIVERIES = `${ADMIN_ROOT}/deliveries`;
export const ADMIN_DELIVERIES_DETAILS = `${ADMIN_ROOT}/deliveries/:id`;
export const ADMIN_ADD_MANUAL_DELIVERY = `${ADMIN_ROOT}/deliveries/add-manual`;

export const PARTNER_SIGN_UP_USER_INFO = `/sign-up/user-info`;
export const PARTNER_SIGN_UP_TERMS = `/sign-up/terms-and-conditions`;
export const PARTNER_SIGN_UP_ADD_LOCATION = `/sign-up/add-location`;
export const PARTNER_SIGN_UP_CONFIRM_LOCATION = `/sign-up/confirm-location`;
export const PARTNER_SIGN_UP_MANUAL_LOCATION = `/sign-up/manual-location`;
export const PARTNER_SIGN_UP_BUSINESS_LICENSE = `/sign-up/business-license`;
export const PARTNER_SIGN_UP_SELECT_PROVIDERS = `/sign-up/select-providers`;
export const PARTNER_SIGN_UP_POS_SETUP = `/sign-up/pos-setup`;
export const PARTNER_SIGN_UP_SUCCESS = `/sign-up/success`;

export const PARTNER_LOCATIONS_ADD_LOCATION = `/locations/add-location`;
export const PARTNER_LOCATIONS_CONFIRM_LOCATION = `/locations/confirm-location`;
export const PARTNER_LOCATIONS_MANUAL_LOCATION = `/locations/manual-location`;
export const PARTNER_LOCATIONS_BUSINESS_LICENSE = `/locations/business-license`;
export const PARTNER_LOCATIONS_SELECT_PROVIDERS = `/locations/select-providers`;
export const PARTNER_LOCATIONS_POS_SETUP = `/locations/pos-setup`;
export const PARTNER_LOCATIONS_SUCCESS = `/locations/success`;

export const PARTNER_TRANSACTIONS = `/transactions`;
export const PARTNER_TRANSACTIONS_PENDING_LOCATION = `/wallet-pending/:id`;

export const PARTNER_LOCATIONS_CHOOSE_LOCATION_TO_ADD_BRAND = `/locations/choose-location-to-add-brand`;

export const PARTNER_V_DRIVE = `/v-drive`;
export const PARTNER_V_DRIVE_ONBOARDING = `/v-drive/onboarding/:id`;

export const PARTNER_INTEGRATION_SETUP = `/integration-setup`;
/*
 * Deliveries (vDrive manager) onboarding. Lib constants rather than app-local
 * ones because AdminLayoutRoot's auth-pathname allow-list must recognise them
 * to render these screens on the auth layout instead of the sidebar chrome.
 */
export const DELIVERIES_WELCOME = `/welcome`;
export const DELIVERIES_COMPLETE_ACCOUNT = `/complete-account`;
/**
 * Where the console lands after login, after an organization switch and on
 * `/`: the dashboard. A lib constant because the shared layout's root
 * redirect needs it.
 */
export const DELIVERIES_HOME = ADMIN_DASHBOARD;

/**
 * Internal chat. The open thread is a `?location=` search param rather than a
 * path param on purpose: both routers render `<Routes key={location.pathname}>`
 * inside `AnimatePresence mode="wait"`, so a path change would remount the whole
 * routed subtree and reset the inbox scroll on every thread click.
 */
export const ADMIN_CHAT = `${ADMIN_ROOT}/chat`;
export const PARTNER_CHAT = `${ADMIN_ROOT}/chat`;
/** Search param carrying the open conversation's id. */
export const CHAT_CONVERSATION_PARAM = 'conversation';

/**
 * The requests the AI triage bot raised for the support team.
 *
 * The open ticket is a search param for the same reason the open conversation
 * is: a path change remounts the routed subtree, and here it would throw away
 * the list and its scroll every time a row is opened. It also makes the ticket
 * linkable from the card in the chat thread.
 */
export const ADMIN_SUPPORT_TICKETS = `${ADMIN_ROOT}/support-tickets`;
export const SUPPORT_TICKET_PARAM = 'ticket';

/**
 * What the backend noticed on its own: a page of its own in the sidebar, with
 * a bar on the Dashboard's Orders tab while something critical is open. It
 * used to be a Dashboard tab, so `/dashboard?tab=problems` still redirects
 * here. The open problem is a search param for the same reason as the open
 * ticket.
 */
export const ADMIN_SYSTEM_PROBLEMS = `${ADMIN_ROOT}/system-problems`;
export const SYSTEM_PROBLEM_PARAM = 'problem';

/**
 * Restaurant-to-restaurant referrals: the admin's view of the whole program,
 * and the merchant's invite page.
 */
export const ADMIN_REFERRALS = `${ADMIN_ROOT}/referrals`;
export const ADMIN_REFERRAL_DETAILS = `${ADMIN_ROOT}/referrals/:id`;
export const PARTNER_REFER_A_RESTAURANT = `${ADMIN_ROOT}/refer-a-restaurant`;

/**
 * Everything the bell has had, admin and merchant alike - the list is the
 * user's own, so one path serves both apps. Reached from the bell's See all,
 * not from the sidebar.
 */
export const ADMIN_NOTIFICATIONS = `${ADMIN_ROOT}/notifications`;

export const adminAuthRoutes = [
  {
    path: ADMIN_LOGIN,
    Page: LoginAdmin,
  },
  {
    path: ADMIN_OTP,
    Page: OtpAdmin,
  },
];
